// Vendor
import * as React from 'react';

// Internal
import { Image } from '@src/components/Image/Image';
import { SlideReveal } from '@src/components/SlideReveal/SlideReveal';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';

const ThredupWeathersCovid: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-xl">
        thredUP Weathers Covid Storm Better Than Competition
      </h1>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 1}
        className="tup-body max-w-2xl mb-12"
      >
        thredUP has maintained <b>20%</b> growth since shelter-in-place orders
        started, while other online shopping destinations dipped <b>24%</b>.
      </p>

      <SlideReveal>
        <Image
          addLink={true}
          alt="Pre and Post Covid weekly sales chart"
          fileName="weeklysales-chart.png"
          maxWidth={871}
        />
      </SlideReveal>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 2}
        className="tup-description"
      >
        Average year-over-year growth in weekly gross transaction value
      </p>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 3}
        className="tup-source max-w-xl"
      >
        *Competitor Benchmark includes an aggregated list of public and private
        apparel companies that sell primarily online. Source:{' '}
        <a
          className="underline"
          href="https://secondmeasure.com/datapoints/fashion-resale-sees-growth/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Second Measure U.S. consumer credit and debit card transaction data
        </a>
      </p>
    </div>
  );
};

export { ThredupWeathersCovid };
